import type React from 'react'
import { HeaderDashboard } from '../header-dashboard'

export interface HeaderProps {
  type?: 'authenticated' | 'unauthenticated'
}

export const Header: React.FC<HeaderProps> = ({ type }) => {
  const getHeader = () => {
    switch (type) {
      case 'authenticated':
        return <HeaderDashboard />
      case 'unauthenticated':
        return (
          <div className="flex justify-center pt-8 pb-4">
            <img
              src={
                'https://storage.googleapis.com/osb-files/dash/logo-primary.png'
              }
              alt="logo"
              className="w-60 object-cover"
            />
          </div>
        )
      default:
        return null
    }
  }
  return <div>{getHeader()}</div>
}
